import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, Spinner, Center, Text } from '@chakra-ui/react';
import { TenantPaymentSimpleInterface } from '../../../../shared/type/finance.type';
import CustomChakraButton from '../../../CustomChakraButton/CustomChakraButton';
import { useTenantFinances } from './useTenantFinances';

interface TenantPaymentsTableTableProps {
  isLoading: boolean;
  onDownloadPaymentReport: (paymentId:number, outputType: 'PDF' | 'XLSX') => void;
  data: TenantPaymentSimpleInterface[];
  headers?: {
    name: string;
    creationDate: string;
    paymentDate: string;
    amount: string;
    actions: string;
    month: string;
  };
}

const TenantPaymentsTable = ({ isLoading, data, headers, onDownloadPaymentReport }: TenantPaymentsTableTableProps) => {
  const columnHeaders = {
    creationDate: headers?.creationDate || 'Data utworzenia',
    paymentDate: headers?.paymentDate || 'Data wykonania przelewu',
    amount: headers?.amount || 'Kwota',
    month: headers?.month || 'Na miesiąc',
    actions: headers?.amount || 'Pobieranie',
  };

  return (
    <Table className="w-full">
      <Thead className="text-xs bg-white">
        <Tr>
          {Object.values(columnHeaders).map((header, index) => (
            <Th
              key={`header-${index}`}
              className="border border-gray-200 py-3 px-4 text-center"
              fontWeight={400}
              textTransform="capitalize">
              {header}
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody className="text-sm font-medium text-grayLight-900">
        {isLoading ? (
          <Tr>
            <Td colSpan={6}>
              <Center py={6}>
                <Spinner size="md" />
              </Center>
            </Td>
          </Tr>
        ) : data.length === 0 ? (
          <Tr>
            <Td colSpan={6}>
              <Center py={6}>
                <Text>Brak danych</Text>
              </Center>
            </Td>
          </Tr>
        ) : (
          data.map((row, index) => (
            <Tr key={`row-${index}`} className="border-t border-x bg-white">
              <Td className="px-4 py-5 text-grayLight-600 text-center">{row.creationDate}</Td>
              <Td className="px-4 py-5 text-grayLight-600 text-center">{row.paymentDate}</Td>
              <Td className="px-4 py-5 text-grayLight-600 text-center">{row.amount}</Td>
              <Td className="px-4 py-5 text-grayLight-600 text-center">{row.month}.{row.year}</Td>
              <Td className="px-4 py-5 text-grayLight-600 text-center">
                <CustomChakraButton
                  hierarchy="primary"
                  size="md"
                  iconPosition="right"
                  dropdownOptions={[
                    { label: 'PDF', action: () => onDownloadPaymentReport(row.id,'PDF') },
                    { label: 'Excel (.xls)', action: () => onDownloadPaymentReport(row.id,'XLSX') }
                  ]}
                  buttonProps={{
                    onClick: () => {
                      return null;
                    }
                  }}>
                  Pobierz raport
                </CustomChakraButton>
              </Td>
            </Tr>
          ))
        )}
      </Tbody>
    </Table>
  );
};

export default TenantPaymentsTable;
